module.exports = __webpack_public_path__ + "static/media/ilustracionMonuks.8b708692.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/home/ilustracionMonuks.png
// module id = 96
// module chunks = 0